import { render, staticRenderFns } from "./DocumentManagement.vue?vue&type=template&id=0b73c906&scoped=true&"
import script from "./DocumentManagement.vue?vue&type=script&lang=js&"
export * from "./DocumentManagement.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManagement.vue?vue&type=style&index=0&id=0b73c906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73c906",
  null
  
)

export default component.exports